import { Filters } from '../api/types/others';
import { Goal } from '../api/types/contentManagement';
import useCustomizedDropdown from './useCustomizedDropdown';

const useFiltersComponent = ({
  pillarTypes,
  goals,
  categories,
}: {
  pillarTypes: string[];
  goals: Goal[];
  categories: string[];
}) => {
  const { props: pillarTypeDropdownProps, setProps: setPillarTypeDropdownProps } = useCustomizedDropdown({
    possibleValues: pillarTypes,
    customType: 'pillarType',
  });
  const { props: goalDropdownProps, setProps: setGoalDropdownProps } = useCustomizedDropdown({
    possibleValues: goals.map((item) => item.name),
  });
  const { props: categoryDropdownProps, setProps: setCategoryDropdownProps } = useCustomizedDropdown({
    possibleValues: categories,
  });

  const dropdownProps = {
    pillarType: pillarTypeDropdownProps,
    goal: goalDropdownProps,
    category: categoryDropdownProps,
  };

  const setDropdownProps = (filters: Filters) => {
    if (filters?.pillars && Array.isArray(filters?.pillars)) {
      setPillarTypeDropdownProps(filters?.pillars);
    }
    if (filters?.goals && Array.isArray(filters?.goals)) {
      setGoalDropdownProps(filters?.goals);
    }
    if (filters?.categories && Array.isArray(filters?.categories)) {
      setCategoryDropdownProps(filters?.categories);
    }
  };

  const getDropdownProps = () => {
    return {
      pillars: dropdownProps.pillarType.selectedItems.map((item) => item?.value),
      goals: dropdownProps.goal.selectedItems.map((item) => item?.value),
      categories: dropdownProps.category.selectedItems.map((item) => item?.value),
    } as Filters;
  };

  const getDidConfigure = () => {
    const currentConfiguration = getDropdownProps();
    const choices =
      currentConfiguration.pillars.length + currentConfiguration.goals.length + currentConfiguration.categories.length;
    return choices > 0;
  };

  return { dropdownProps, setDropdownProps, getDropdownProps, getDidConfigure };
};
export default useFiltersComponent;
